// extracted by mini-css-extract-plugin
module.exports = {"core":"contactform-module--core--3SE4X","label":"contactform-module--label--3ULIV","checkbox":"contactform-module--checkbox--3BFk4"};